var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import _ from "lodash";
import draggable from 'vuedraggable';
var audios = [
    { id: 1, provider: "myouseek", provider_id: "1", previewSource: "https://myouseek.com/audio/1.mp3", },
    { id: 2, provider: "myouseek", provider_id: "2", previewSource: "https://myouseek.com/audio/2.mp3", },
    { id: 3, provider: "myouseek", provider_id: "3", previewSource: "https://myouseek.com/audio/3.mp3", },
    { id: 4, provider: "myouseek", provider_id: "4", previewSource: "https://myouseek.com/audio/4.mp3", },
    { id: 5, provider: "myouseek", provider_id: "5", previewSource: "https://myouseek.com/audio/5.mp3", },
    { id: 6, provider: "myouseek", provider_id: "6", previewSource: "https://myouseek.com/audio/6.mp3", },
];
var playlist = {
    id: 3,
    title: "Test Playlist",
    audios: audios,
};
var AudioPlayer = (function (_super) {
    __extends(AudioPlayer, _super);
    function AudioPlayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.player = {
            state: 0,
            time: 0,
            repeat: 0,
            shuffle: false,
            position: null,
            audio: null,
            playlist: [],
            provider: "",
            alteringPlaylist: false,
        };
        _this.buffer = 0;
        _this.bufferValue = 0;
        _this.tooltipTime = "";
        _this.playlist1 = { id: 1, title: "Test Playlist 1", audios: audios.slice(0, 3) };
        _this.playlist2 = { id: 2, title: "Test Playlist 2", audios: audios.slice(3, 6) };
        _this.playlist3 = { id: 2, title: "Test Playlist 3", audios: _this["$deepcopy"](audios) };
        _this.audiosNotInPlaylist = [
            { id: 3, provider: "myouseek", provider_id: "3", previewSource: "https://myouseek.com/audio/3.mp3", },
            { id: 4, provider: "myouseek", provider_id: "4", previewSource: "https://myouseek.com/audio/4.mp3", },
            { id: 5, provider: "myouseek", provider_id: "5", previewSource: "https://myouseek.com/audio/5.mp3", },
        ];
        _this.draggableOptions = {
            disabled: false,
            handle: '.handle',
            ghostClass: 'ghost',
            setData: function (dataTransfer) {
                dataTransfer.setDragImage(document.createElement('div'), 0, 0);
            },
        };
        return _this;
    }
    Object.defineProperty(AudioPlayer.prototype, "audioElement", {
        get: function () {
            return this.$refs["audio"];
        },
        enumerable: true,
        configurable: true
    });
    ;
    AudioPlayer.prototype.onDragStart = function () {
        this.player.alteringPlaylist = true;
    };
    AudioPlayer.prototype.onDragEnd = function (e) {
        var _this = this;
        if (e.oldIndex === this.player.position) {
            this.player.position = e.newIndex;
        }
        else if (e.newIndex <= this.player.position && e.oldIndex > this.player.position) {
            this.player.position++;
        }
        else if (e.newIndex >= this.player.position && e.oldIndex < this.player.position) {
            this.player.position--;
        }
        this.$nextTick(function () {
            _this.player.alteringPlaylist = false;
        });
    };
    AudioPlayer.prototype.remove = function (index) {
        var _this = this;
        this.player.alteringPlaylist = true;
        this.player.playlist.splice(index, 1);
        if (index <= this.player.position) {
            this.player.alteringPlaylist = true;
            this.player.position--;
            this.player.alteringPlaylist = false;
        }
        this.$nextTick(function () {
            _this.player.alteringPlaylist = false;
        });
    };
    Object.defineProperty(AudioPlayer.prototype, "isPlaylingLast", {
        get: function () {
            if (!this.player.playlist) {
                return false;
            }
            return this.player.position === this.player.playlist.length - 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AudioPlayer.prototype, "canNext", {
        get: function () {
            return this.player.repeat === 2 || !this.isPlaylingLast;
        },
        enumerable: true,
        configurable: true
    });
    AudioPlayer.prototype.playNext = function () {
        if (this.player.repeat === 2 && this.isPlaylingLast) {
            this.player.position = 0;
        }
        else {
            this.player.position++;
        }
    };
    AudioPlayer.prototype.playPrevious = function () {
        if (this.player.position === 0) {
            this.player.time = 0;
            this.audioElement.currentTime = 0;
        }
        else {
            this.player.position--;
        }
    };
    AudioPlayer.prototype.toggleRepeat = function () {
        if (this.player.repeat === 2) {
            this.player.repeat = 0;
        }
        else {
            this.player.repeat++;
        }
    };
    AudioPlayer.prototype.onStateChange = function (newVal, oldVal) {
        var _this = this;
        var player = this.player;
        if (newVal === 0) {
            if (player.repeat === 1) {
                player.time = 0;
                player.state = 1;
            }
            else if ((_.last(player.playlist).id === player.audio.id) && (player.repeat === 2)) {
                player.audio = player.playlist[0];
                player.time = 0;
                player.state = 1;
            }
        }
        else if (newVal === 1) {
            if (oldVal === 0) {
                this.audioElement.currentTime = 0;
            }
            setTimeout(function () {
                _this.audioElement.play();
            });
        }
        else if (newVal === 2) {
            this.audioElement.pause();
        }
    };
    AudioPlayer.prototype.onShuffleChanged = function (newVal) {
        if (newVal) {
            var part1 = this.player.playlist.slice(0, this.player.position + 1);
            var part2 = this.player.playlist.slice(this.player.position + 1);
            var shuffled = _.shuffle(part2);
            this.player.playlist = _.concat(part1, shuffled);
        }
    };
    AudioPlayer.prototype.onTimeChange = function (newTime, oldTime) {
        this.buffer = (newTime / this.audioElement.duration) * 100;
        this.bufferValue = this.calculateBuffered(this.audioElement);
        if (this.player.state === 0) {
            this.player.state = 1;
        }
        else if (newTime === this.player.audio.duration) {
            this.player.state = 0;
        }
    };
    AudioPlayer.prototype.onPositionChange = function (newPosition, oldPosition) {
        var _this = this;
        if (this.player.alteringPlaylist) {
            return;
        }
        this.player.state = 0;
        this.player.time = 0;
        this.player.audio = this.player.playlist[newPosition];
        this.$nextTick(function () {
            _this.player.state = 1;
        });
    };
    AudioPlayer.prototype.onAudioChange = function (newAudio, oldAudio) {
        var _this = this;
        this.player.time = 0;
        if (this.audioElement) {
            this.audioElement.load();
        }
        if (this.player.state === 1) {
            setTimeout(function () {
                _this.audioElement.play();
            });
        }
    };
    Object.defineProperty(AudioPlayer.prototype, "src", {
        get: function () {
            return this.player.audio.previewSource;
        },
        enumerable: true,
        configurable: true
    });
    AudioPlayer.prototype.calculateBuffered = function (audioElement) {
        if (audioElement === void 0) { audioElement = null; }
        if (!audioElement) {
            audioElement = this.audioElement;
        }
        var buffered = 0;
        if (audioElement.buffered.length) {
            var x = 0;
            while (x < audioElement.buffered.length && audioElement.buffered.start(x) < audioElement.currentTime) {
                ++x;
            }
            if (x < 1)
                x = 1;
            buffered = (audioElement.buffered.end(x - 1) / audioElement.duration) * 100;
        }
        return buffered;
    };
    AudioPlayer.prototype.mounted = function () {
        var _this = this;
        this.audioElement.addEventListener("seeked", function (e) {
            _this.player.time = e.target.currentTime;
        });
        this.audioElement.addEventListener("timeupdate", function (e) {
            _this.player.time = _this.audioElement.currentTime;
        });
        this.audioElement.addEventListener("progress", function (e) {
            _this.bufferValue = _this.calculateBuffered(e.target);
        });
        this.audioElement.addEventListener("ended", function (e) {
            _this.player.state = 0;
            _this.$nextTick(function () {
                if (_this.player.repeat === 1) {
                    _this.player.time = 0;
                    _this.player.state = 1;
                }
                else {
                    if (_this.player.position < _this.player.playlist.length - 1) {
                        _this.player.position++;
                    }
                    else {
                        if (_this.player.repeat === 2) {
                            _this.player.position = 0;
                        }
                    }
                }
            });
        });
    };
    AudioPlayer.prototype.playAudio = function (audio, playlist, position) {
        if (playlist === void 0) { playlist = null; }
        if (position === void 0) { position = 0; }
        if (playlist) {
            this.player.playlist = playlist.audios;
            this.player.position = position;
        }
        else {
            if (!this.player.audio || this.player.audio.id !== audio.id) {
                this.player.playlist.push(audio);
            }
            this.player.position = this.player.playlist.length - 1;
        }
        this.player.audio = audio;
    };
    AudioPlayer.prototype.playPlaylistRandomized = function (playlist) {
        this.player.position = 0;
        this.player.time = 0;
        this.player.playlist = _.shuffle(playlist.audios);
        this.player.audio = this.player.playlist[0];
    };
    AudioPlayer.prototype.playPlaylist = function () {
        this.player.playlist = playlist.audios;
    };
    AudioPlayer.prototype.onClick = function (e) {
        var target = e.target.parentElement.parentElement;
        var totalWidth = target.offsetWidth;
        var clickedWidth = e.offsetX;
        var percentageClicked = (clickedWidth / totalWidth);
        this.audioElement.currentTime = percentageClicked * this.audioElement.duration;
    };
    AudioPlayer.prototype.formatTime = function (time) {
        time = Math.round(time);
        var minutes = Math.floor(time / 60), seconds = time - minutes * 60, sSeconds = seconds < 10 ? "0" + seconds : seconds;
        return minutes + ":" + sSeconds;
    };
    AudioPlayer.prototype.showTime = function (e) {
        if (!this.player.audio) {
            return;
        }
        var target = e.target.parentElement.parentElement, totalWidth = target.offsetWidth, clickedWidth = e.offsetX, percentageHovered = (clickedWidth / totalWidth) * 100;
        this.tooltipTime = this.formatTime((percentageHovered / 100) * this.player.time);
        this.$refs.time["style"].display = "block";
        var tooltipWidth = 60;
        if (e.offsetX > tooltipWidth / 2 && e.offsetX < totalWidth - tooltipWidth / 2) {
            this.$refs.time["style"].left = e.offsetX - tooltipWidth / 2 + "px";
        }
        else if (e.offsetX <= tooltipWidth / 2) {
            this.$refs.time["style"].left = 0;
        }
        else if (e.offsetX > totalWidth - tooltipWidth / 2) {
            this.$refs.time["style"].left = totalWidth - tooltipWidth + "px";
        }
    };
    AudioPlayer.prototype.hideTime = function (e) {
        this.$refs.time["style"].display = "none";
    };
    __decorate([
        Watch("player.state"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], AudioPlayer.prototype, "onStateChange", null);
    __decorate([
        Watch("player.shuffle"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AudioPlayer.prototype, "onShuffleChanged", null);
    __decorate([
        Watch("player.time"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], AudioPlayer.prototype, "onTimeChange", null);
    __decorate([
        Watch("player.position"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], AudioPlayer.prototype, "onPositionChange", null);
    __decorate([
        Watch("player.audio.id"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], AudioPlayer.prototype, "onAudioChange", null);
    AudioPlayer = __decorate([
        Component({
            components: {
                draggable: draggable,
            },
        })
    ], AudioPlayer);
    return AudioPlayer;
}(Vue));
export default AudioPlayer;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioPlayer.vue
// module id = 211
// module chunks = 0